"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Title1", {
    enumerable: true,
    get: function() {
        return Title1;
    }
});
const _createPreset = require("../createPreset");
const _useTitle1Stylesstyles = require("./useTitle1Styles.styles");
const Title1 = (0, _createPreset.createPreset)({
    useStyles: _useTitle1Stylesstyles.useTitle1Styles,
    className: _useTitle1Stylesstyles.title1ClassNames.root,
    displayName: 'Title1'
});
